import { WidgetDef } from '../../../types';

/**
 * Canonical widgets for the `cases` page. Each `widgetId` is the stable id used
 * by `AccountCustomization#content.widgets.cases[].widgetId` in upstack_api.
 *
 * Cross-repo coupling: when adding/renaming/removing a widget here, mirror the
 * change in upstack_api at `app/models/account_customization.rb`
 * (`AccountCustomization::WIDGET_CATALOG["cases"]`) and bump the count
 * assertion in `spec/models/account_customization_spec.rb`. See `docs/mcp.md`
 * in upstack_api for the protocol.
 */
export const CasesWidgetDefs: WidgetDef[] = [
  { widgetId: 'cases', headerName: 'Cases', index: 0, hide: false, disabled: false }
];
